<div class="ContentCodeSelectorStep my-5">
  <div class="row">
    <div
      class="col col-12 col-md-3 d-flex align-items-center justify-content-end">
      <mat-label>Content code</mat-label>
    </div>
    <div class="col col-12 col-md-9">
      <mat-form-field class="w-100">
        <mat-label>Content code</mat-label>
        <input
          matInput
          name="card_number"
          [ngModel]="contentCode"
          (ngModelChange)="contentCodeChange($event)" />
        <mat-hint
          >Hint: Content code can be content group name of your contents or a
          specific code, given to you by admins</mat-hint
        >
      </mat-form-field>
    </div>
  </div>
</div>
